export default function LazyElementComponent(module) {
    angular.module(module || 'app')
        .component('lazyElement', {
            bindings: {
                markup: '@'
            },
            controller: LazyElementController
        });

    LazyElementController.$inject = ['$scope', '$element'];
    function LazyElementController($scope, $element) {
        var vm = this;
        vm.$onInit = function () {
            vm._clearListener = $scope.$on('loadLazyElement', function (event, data) {
                vm._load(data);
            });
        };

        vm._load = function (data) {
            $element.html(vm.markup);
            $element.addClass('loaded');
            vm._clearListener();
            $scope.$emit('lazyElementLoaded', data);
        }
    }
};